<template>
    <div>
        <ul class="list-disc pl-4  font-light text-xl mb-6">
            <li>
                Following identification of <span class="italic">AGXT</span> mutation in the patient, familial screening identified that the parents and two siblings were carriers:
                <ul class="list-disc pl-6  font-light text-xl">
                    <li>Additional family members were diseased while other family members (maternal and parental) were not tested due to refusal to undergo testing, distance, or having passed away</li>
                </ul>
            </li>
        </ul>

        <div class="w-full overflow-x-auto">
            <img
                src="@/assets/img/graphics/adolescent/family-screening.png"
                alt="Genetic Testing"
                class="max-w-fit sm:max-w-full object-contain"
            />
        </div>
    </div>
</template>
